(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function normalizeLang(lang) {
    return String(lang || 'en').toLowerCase().split('-')[0];
  }

  function normalizeCountryCode(code) {
    return String(code || '').toLowerCase();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function waitForWeglot(callback, attempt) {
    attempt = attempt || 0;

    if (
      window.Weglot &&
      typeof window.Weglot.getCurrentLang === 'function' &&
      typeof window.Weglot.switchTo === 'function'
    ) {
      callback();
      return;
    }

    if (attempt >= 60) {
      callback();
      return;
    }

    setTimeout(function () {
      waitForWeglot(callback, attempt + 1);
    }, 150);
  }

  ready(function () {
    var root = document.querySelector('[data-shopify-locale-switcher]');
    var triggers = document.querySelectorAll('[data-locale-trigger]');
    var triggerFlags = document.querySelectorAll('[data-trigger-country-flag]');
    var modal = document.querySelector('[data-locale-modal]');
    var closeButtons = document.querySelectorAll('[data-locale-close], [data-locale-cancel]');
    var saveButton = document.querySelector('[data-locale-save]');

    if (!root || !triggers.length || !modal || !saveButton) return;

    var countryToggle = root.querySelector('[data-country-toggle]');
    var countryPanel = root.querySelector('[data-country-panel]');
    var countryCurrent = root.querySelector('[data-country-current]');
    var countryInput = root.querySelector('[data-country-input]');
    var countryForm = root.querySelector('[data-locale-country-form]');
    var countryOptions = root.querySelectorAll('[data-country-option]');
    var currencyView = root.querySelector('[data-currency-view]');

    var languageToggle = root.querySelector('[data-language-toggle]');
    var languagePanel = root.querySelector('[data-language-panel]');
    var languageCurrent = root.querySelector('[data-language-current]');
    var languageList = root.querySelector('[data-language-list]');

    if (
      !countryInput ||
      !countryForm ||
      !countryToggle ||
      !countryPanel ||
      !countryCurrent ||
      !currencyView ||
      !languageToggle ||
      !languagePanel ||
      !languageCurrent ||
      !languageList
    ) {
      return;
    }

    var initialCountry = countryInput.value;
    var selectedCountry = countryInput.value;
    var initialLang = getCurrentLangSafe();
    var selectedLang = initialLang;
    var lastFocusedElement = null;
    var hasBoundWeglotLanguageChanged = false;
    var hasBoundWeglotSwitchersReady = false;

    waitForWeglot(function () {
      initialLang = getCurrentLangSafe();
      selectedLang = initialLang;

      bindWeglotEvents();
      buildLanguageListWhenReady(0);
      renderAllTriggerCountryFlags(normalizeCountryCode(initialCountry), getCountryCurrentPlainLabel());
      renderCountryCurrent(normalizeCountryCode(initialCountry), getCountryCurrentPlainLabel());
      syncSaveState();
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', openModal);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-active')) return;
      if (event.key === 'Escape') closeModal();
    });

    document.addEventListener('click', function (event) {
      if (!modal.classList.contains('is-active')) return;

      if (
        countryPanel &&
        !countryPanel.hasAttribute('hidden') &&
        !countryToggle.contains(event.target) &&
        !countryPanel.contains(event.target)
      ) {
        countryPanel.setAttribute('hidden', '');
        countryToggle.setAttribute('aria-expanded', 'false');
      }

      if (
        languagePanel &&
        !languagePanel.hasAttribute('hidden') &&
        !languageToggle.contains(event.target) &&
        !languagePanel.contains(event.target)
      ) {
        languagePanel.setAttribute('hidden', '');
        languageToggle.setAttribute('aria-expanded', 'false');
      }
    });

    countryToggle.addEventListener('click', function () {
      var willOpen = countryPanel.hasAttribute('hidden');

      if (willOpen) {
        countryPanel.removeAttribute('hidden');
        countryToggle.setAttribute('aria-expanded', 'true');
        languagePanel.setAttribute('hidden', '');
        languageToggle.setAttribute('aria-expanded', 'false');
      } else {
        countryPanel.setAttribute('hidden', '');
        countryToggle.setAttribute('aria-expanded', 'false');
      }
    });

    languageToggle.addEventListener('click', function () {
      var willOpen = languagePanel.hasAttribute('hidden');

      if (willOpen) {
        languagePanel.removeAttribute('hidden');
        languageToggle.setAttribute('aria-expanded', 'true');
        countryPanel.setAttribute('hidden', '');
        countryToggle.setAttribute('aria-expanded', 'false');
        buildLanguageListWhenReady(0);
      } else {
        languagePanel.setAttribute('hidden', '');
        languageToggle.setAttribute('aria-expanded', 'false');
      }
    });

    countryOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        selectedCountry = option.getAttribute('data-value') || '';
        var label = option.getAttribute('data-label') || '';
        var currency = option.getAttribute('data-currency') || '';
        var flagCode = option.getAttribute('data-country-flag') || '';

        countryInput.value = selectedCountry;
        renderCountryCurrent(flagCode, label);
        currencyView.value = currency;
        renderAllTriggerCountryFlags(flagCode, label);

        countryOptions.forEach(function (item) {
          item.classList.remove('is-active');
        });

        option.classList.add('is-active');
        countryPanel.setAttribute('hidden', '');
        countryToggle.setAttribute('aria-expanded', 'false');
        syncSaveState();
      });
    });

    saveButton.addEventListener('click', function () {
      if (saveButton.classList.contains('is-loading')) return;

      var countryChanged = selectedCountry !== initialCountry;

      if (!countryChanged) {
        closeModal();
        return;
      }

      saveButton.classList.add('is-loading');
      countryInput.value = selectedCountry;
      HTMLFormElement.prototype.submit.call(countryForm);
    });

    function setTriggersExpanded(isExpanded) {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    }

    function openModal(event) {
      lastFocusedElement = event && event.currentTarget ? event.currentTarget : document.activeElement;
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      setTriggersExpanded(true);
      document.body.classList.add('shopify-locale-switcher--locked');
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      setTriggersExpanded(false);
      document.body.classList.remove('shopify-locale-switcher--locked');
      saveButton.classList.remove('is-loading');

      countryPanel.setAttribute('hidden', '');
      countryToggle.setAttribute('aria-expanded', 'false');
      languagePanel.setAttribute('hidden', '');
      languageToggle.setAttribute('aria-expanded', 'false');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function getCountryCurrentPlainLabel() {
      if (!countryCurrent) return initialCountry;
      var labelNode = countryCurrent.querySelector('.shopify-locale-switcher__country-label');
      if (labelNode) return labelNode.textContent.trim();
      return countryCurrent.textContent.trim() || initialCountry;
    }

    function getCurrentLangSafe() {
      try {
        if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
          return normalizeLang(window.Weglot.getCurrentLang() || 'en');
        }
      } catch (error) {}
      return normalizeLang(document.documentElement.lang || 'en');
    }

    function getExpectedLanguageCount() {
      try {
        var from = window.Weglot && window.Weglot.options && window.Weglot.options.language_from ? 1 : 0;
        var to = window.Weglot && window.Weglot.options && Array.isArray(window.Weglot.options.languages) ? window.Weglot.options.languages.length : 0;
        return from + to;
      } catch (error) {
        return 0;
      }
    }

    function getFallbackFlagCode(code) {
      var normalized = normalizeLang(code);
      var map = { en: 'gb', de: 'de', nl: 'nl', fr: 'fr', it: 'it', es: 'es', ko: 'kr', ja: 'jp' };
      return map[normalized] || normalized;
    }

    function getLanguageNameSafe(lang, fallbackLabel) {
      try {
        if (window.Weglot && typeof window.Weglot.getLanguageName === 'function') {
          var result = window.Weglot.getLanguageName(normalizeLang(lang));
          if (result && result.replace(/\s+/g, '').length > 2) return result;
        }
      } catch (error) {}
      return fallbackLabel || normalizeLang(lang).toUpperCase();
    }

    function getLanguageFlagSrc(code, flagSrc) {
      if (flagSrc && /^https?:\/\//.test(flagSrc)) return flagSrc;
      return 'https://cdn.weglot.com/flags/rectangle_mat/' + getFallbackFlagCode(code) + '.svg';
    }

    function getLanguageDataFromDomOption(optionNode) {
      if (!optionNode) return null;

      var code = normalizeLang(optionNode.getAttribute('data-l') || optionNode.dataset.value || '');
      if (!code) return null;

      var img = optionNode.querySelector('img.wg-flag');
      var link = optionNode.querySelector('a');
      var rawLabel = link ? link.textContent.replace(/\s+/g, ' ').trim() : optionNode.textContent.replace(/\s+/g, ' ').trim();

      return {
        code: code,
        label: getLanguageNameSafe(code, rawLabel),
        flagSrc: getLanguageFlagSrc(code, img ? img.getAttribute('src') : '')
      };
    }

    function getLanguagesFromWeglotDom() {
      var switcher = document.querySelector('.weglot-container .weglot_switcher');
      if (!switcher) return [];

      var items = [];
      var current = switcher.querySelector('.active-language.language-option');
      var others = switcher.querySelectorAll('.language-list .language-option');

      if (current) items.push(current);
      others.forEach(function (node) {
        items.push(node);
      });

      var seen = {};
      var result = [];

      items.forEach(function (node) {
        var data = getLanguageDataFromDomOption(node);
        if (!data || !data.code || seen[data.code]) return;
        seen[data.code] = true;
        result.push(data);
      });

      return result;
    }

    function getLanguagesFromWeglotOptions() {
      var langs = [];

      try {
        langs = (window.Weglot.options.languages || [])
          .map(function (language) {
            return normalizeLang(language.language_to);
          })
          .concat(normalizeLang(window.Weglot.options.language_from));
      } catch (error) {
        langs = [normalizeLang(initialLang)];
      }

      return langs
        .filter(function (value, index, array) {
          return value && array.indexOf(value) === index;
        })
        .map(function (code) {
          return {
            code: code,
            label: getLanguageNameSafe(code),
            flagSrc: getLanguageFlagSrc(code, '')
          };
        });
    }

    function getReliableWeglotLanguages() {
      var expectedCount = getExpectedLanguageCount();
      var fromDom = getLanguagesFromWeglotDom();

      if (fromDom.length && (expectedCount === 0 || fromDom.length >= expectedCount)) {
        return fromDom;
      }

      var fromOptions = getLanguagesFromWeglotOptions();
      if (fromDom.length > fromOptions.length) return fromDom;
      return fromOptions;
    }

    function buildLanguageListWhenReady(attempt) {
      attempt = attempt || 0;

      var languages = getReliableWeglotLanguages();
      var expectedCount = getExpectedLanguageCount();

      if ((!languages.length || (expectedCount > 0 && languages.length < expectedCount)) && attempt < 25) {
        setTimeout(function () {
          buildLanguageListWhenReady(attempt + 1);
        }, 220);
        return;
      }

      buildLanguageList(languages);
    }

    function buildLanguageList(languages) {
      if (!languageList) return;

      if (!languages || !languages.length) {
        languageCurrent.textContent = 'Language unavailable';
        languageList.innerHTML = '';
        return;
      }

      languageList.innerHTML = '';

      languages.forEach(function (data) {
        var li = document.createElement('li');
        li.className = 'shopify-locale-switcher__language-item';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'shopify-locale-switcher__language-option' + (data.code === normalizeLang(initialLang) ? ' is-active' : '');
        button.setAttribute('data-language-option', '');
        button.setAttribute('data-value', data.code);
        button.setAttribute('data-label', data.label);
        button.setAttribute('data-flag', data.flagSrc || '');

        var name = document.createElement('span');
        name.className = 'shopify-locale-switcher__language-name';

        var img = document.createElement('img');
        img.className = 'shopify-locale-switcher__language-flag';
        img.src = data.flagSrc || getLanguageFlagSrc(data.code, '');
        img.alt = '';
        img.width = 24;
        img.height = 16;
        img.onerror = function () {
          this.onerror = null;
          this.src = getLanguageFlagSrc(data.code, '');
        };

        var text = document.createElement('span');
        text.className = 'shopify-locale-switcher__language-label';
        text.textContent = data.label;

        name.appendChild(img);
        name.appendChild(text);

        var check = document.createElement('span');
        check.className = 'shopify-locale-switcher__language-check';
        check.textContent = '✓';

        button.appendChild(name);
        button.appendChild(check);
        li.appendChild(button);
        languageList.appendChild(li);

        button.addEventListener('click', function () {
          if (saveButton.classList.contains('is-loading')) return;

          languageList.querySelectorAll('[data-language-option]').forEach(function (item) {
            item.classList.remove('is-active');
          });

          button.classList.add('is-active');

          languagePanel.setAttribute('hidden', '');
          languageToggle.setAttribute('aria-expanded', 'false');

          saveButton.classList.add('is-loading');

          ensureLanguageApplied(data.code, function (success) {
            saveButton.classList.remove('is-loading');

            if (!success) {
              console.warn('[locale-switcher] Language change could not be confirmed.');
              buildLanguageListWhenReady(0);
              return;
            }

            initialLang = data.code;
            selectedLang = data.code;
            renderLanguageCurrent({
              code: data.code,
              label: data.label,
              flagSrc: data.flagSrc || getLanguageFlagSrc(data.code, '')
            });
            syncSaveState();
          });
        });
      });

      var currentData = languages.find(function (item) {
        return normalizeLang(item.code) === normalizeLang(initialLang);
      }) || languages[0];

      renderLanguageCurrent(currentData);
    }

    function renderLanguageCurrent(langOrData) {
      if (!languageCurrent) return;

      var data = typeof langOrData === 'string'
        ? (getReliableWeglotLanguages().find(function (item) {
            return normalizeLang(item.code) === normalizeLang(langOrData);
          }) || {
            code: normalizeLang(langOrData),
            label: getLanguageNameSafe(langOrData),
            flagSrc: getLanguageFlagSrc(langOrData, '')
          })
        : langOrData;

      var safeFlagSrc = data.flagSrc || getLanguageFlagSrc(data.code, '');

      languageCurrent.innerHTML =
        '<img class="shopify-locale-switcher__language-flag" src="' +
        escapeHtml(safeFlagSrc) +
        '" alt="" width="28" height="18">' +
        '<span class="shopify-locale-switcher__language-label">' +
        escapeHtml(data.label || data.code) +
        '</span>';

      var currentImg = languageCurrent.querySelector('.shopify-locale-switcher__language-flag');
      if (currentImg) {
        currentImg.onerror = function () {
          this.onerror = null;
          this.src = getLanguageFlagSrc(data.code, '');
        };
      }
    }

    function renderTriggerCountryFlag(flagCode, label, node) {
      if (!node || !flagCode) return;

      node.innerHTML =
        '<img src="https://cdn.shopify.com/static/images/flags/' +
        normalizeCountryCode(flagCode) +
        '.svg" alt="' +
        escapeHtml(label || flagCode.toUpperCase()) +
        '" width="20" height="20">';
    }

    function renderAllTriggerCountryFlags(flagCode, label) {
      triggerFlags.forEach(function (flagNode) {
        renderTriggerCountryFlag(flagCode, label, flagNode);
      });
    }

    function renderCountryCurrent(flagCode, label) {
      if (!countryCurrent) return;

      countryCurrent.innerHTML =
        '<img class="shopify-locale-switcher__country-flag" src="https://cdn.shopify.com/static/images/flags/' +
        normalizeCountryCode(flagCode) +
        '.svg" alt="' +
        escapeHtml(label || flagCode.toUpperCase()) +
        '" width="24" height="24">' +
        '<span class="shopify-locale-switcher__country-label">' +
        escapeHtml(label || '') +
        '</span>';
    }

    function bindWeglotEvents() {
      if (window.Weglot && typeof window.Weglot.on === 'function') {
        if (!hasBoundWeglotLanguageChanged) {
          hasBoundWeglotLanguageChanged = true;

          window.Weglot.on('languageChanged', function (lang) {
            var changedLang = normalizeLang(lang);
            initialLang = changedLang;
            selectedLang = changedLang;

            buildLanguageListWhenReady(0);
            syncSaveState();
          });
        }

        if (!hasBoundWeglotSwitchersReady) {
          hasBoundWeglotSwitchersReady = true;

          window.Weglot.on('switchersReady', function () {
            buildLanguageListWhenReady(0);
          });
        }
      }
    }

    function switchLanguageDirect(lang) {
      try {
        if (window.Weglot && typeof window.Weglot.switchTo === 'function') {
          window.Weglot.switchTo(normalizeLang(lang));
        }
      } catch (error) {
        console.warn('[locale-switcher] Weglot switchTo error:', error);
      }
    }

    function waitUntilLanguageMatches(targetLang, timeout, callback) {
      var normalizedTarget = normalizeLang(targetLang);
      var start = Date.now();
      var intervalId = null;

      function check() {
        var currentLang = normalizeLang(getCurrentLangSafe());

        if (currentLang === normalizedTarget) {
          if (intervalId) clearInterval(intervalId);
          callback(true);
          return;
        }

        if (Date.now() - start >= timeout) {
          if (intervalId) clearInterval(intervalId);
          callback(false);
        }
      }

      check();
      intervalId = setInterval(check, 120);
    }

    function ensureLanguageApplied(targetLang, callback) {
      var maxAttempts = 3;
      var attempt = 0;

      function runAttempt() {
        attempt += 1;
        switchLanguageDirect(targetLang);

        waitUntilLanguageMatches(targetLang, 2200, function (matched) {
          if (matched) {
            if (typeof callback === 'function') callback(true);
            return;
          }

          if (attempt < maxAttempts) {
            runAttempt();
            return;
          }

          if (typeof callback === 'function') callback(false);
        });
      }

      waitForWeglot(function () {
        runAttempt();
      });
    }

    function syncSaveState() {
      var countryChanged = selectedCountry !== initialCountry;

      if (countryChanged) {
        saveButton.classList.add('is-ready');
      } else {
        saveButton.classList.remove('is-ready');
      }
    }
  });
})();